import UsersList from './views/UserList'
import UserEdit from './views/UserEdit'
import UserCreate from './views/UserCreate'

export default {
  name:"users",
  list:UsersList,
  edit:UserEdit,
  create:UserCreate,
}